import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.span`
  color: ${props => props.theme.bodyColor};
  font: 700 14px/120% ${props => props.theme.fontFamilyBody};
`;

export default function DropdownLabel({ contributors }) {
  const selectedContributors = contributors.filter(c => c.selected);
  const allSelected = contributors.length === selectedContributors.length;
  const text = !allSelected
    ? `${selectedContributors.length} contributor${selectedContributors.length > 1 ? 's' : ''}`
    : 'all contributors';

  return <Text>{text}</Text>;
}

DropdownLabel.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({
    selected: PropTypes.bool.isRequired,
  })).isRequired,
};
